import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueEasyLightbox from "vue-easy-lightbox";
import VCalendar from "v-calendar";
import "v-calendar/style.css";

import VueGtag from "vue-gtag";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

// importing the helper
import interceptorsSetup from "@/shared/helpers/interceptors";
// and running it somewhere here
interceptorsSetup();

const app = createApp(App);

app.use(router);
app.use(VueEasyLightbox);
app.use(VCalendar, {});
app.use(VueSweetalert2);

app.use(
  VueGtag,
  {
    //config: { id: "UA-1234567-1" }
    config: {
      id: "UA-70816763-1",
      send_page_view: false,
      useDebugger: true,
    },
  },
  router
);

app.mount("#app");
